<template>
    <c-app-bar
        :title         = "title"
        :categories    = "categories"
        :enable-search = "false"
    >
        <template v-slot:search>
            <!-- Search criteria input -->
            <div class=" ml-3">
                <v-text-field
                    outlined
                    hide-details
                    dense
                    v-model="criteria"
                    clearable
                    clear-icon="mdi-close-circle"

                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
            </div>
            <!-- Search criteria input -->

            <div class="v-flex">
                <c-toolbar-button
                    icon     = "mdi-home"
                    color    = "primary"
                    :size    = "22"
                    :tooltip = "$t('home.button')"
                    class    = "ml-2"
                    @click   = "onHome"
                />

                <slot name="toolbar" />
            </div>
            <div class="pl-5 grow primary--text" style="text-align: center">
                {{ selected }}
            </div>
        </template>
    </c-app-bar>
</template>

<script>
import CAppBar from "@/modules/core/components/app/CAppBar";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";

export default {
    name: "CompanyAppBar",
    components: {
        CToolbarButton,
        CAppBar,
    },

    props: {
        title: {
            required: true,
        },

        categories: {
            required: true,
            type    : Array,
            default : function () {
                return null;
            }
        },
    },

    data: () => ({
        criteria: null,
    }),

    watch: {
        criteria: function () {
            this.$emit ("search", this.criteria);
        }
    },

    computed: {
        selected () {
            return this.$store.getters.title;
        }
    },

    methods: {
        onClearFilter () {
            this.criteria = null;
            this.$emit("clear-filter")
        },

        onHome () {
            this.$router.push ({name: "home"})
        },
    }
}
</script>

<style scoped>

::v-deep .v-input__slot {
    min-height: 35px!important;
}

::v-deep .v-input__append-inner {
    margin-top: 5px!important;
}

</style>
